<footer class="c-footer">
  <div>
    <span [innerHTML]="'footerCopyrightText' | translate : { year: year }"></span> 
  </div>
  <div class="link-wrapper">
    <a href="//graphisoft.com/info/about_graphisoft" title="{{'footerLink_1' | translate}}" target="_blank">{{'footerLink_1' | translate}}</a>
    <a href="//graphisoft.com/info/legal/privacy_policy" title="{{'footerLink_2' | translate}}" target="_blank">{{'footerLink_2' | translate}}</a>
    <a href="//graphisoft.com/info/legal/terms_of_use" title="{{'footerLink_3' | translate}}" target="_blank">{{'footerLink_3' | translate}}</a>
  </div>

  <div>
    <span [innerHTML]="'footerText' | translate"></span>
  </div>
</footer>
